import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../../Confirmation'
import { useDocFlowContext } from '../useDocFlowContext'

import {
  getAttentionText,
  isDocFlowDeletingAllTableItems,
} from './useDocFlowProhibitDeleteLastTableItem.utils'

export function useDocFlowProhibitDeleteLastTableItem({
  excludeIds,
  getDeleteItemHandler,
  getMassActionHandler,
  massActionName,
  selectAllPages,
  selectedIds,
  tableItems,
  unfilteredTotal,
}) {
  const { handleCloseModal, setModal } = useDocFlowContext()

  const { t } = useTranslation()

  function handleDelete({ action, item }) {
    const isMassAction = action === massActionName

    if (
      isDocFlowDeletingAllTableItems({
        excludeIds,
        isMassAction,
        selectAllPages,
        selectedIds,
        tableItems,
        unfilteredTotal,
      })
    ) {
      setModal(
        <ConfirmationModal
          actionButtonsProps={{
            Cancel: null,
            submitText: t('Modal.CommonConfirmBtnKey'),
          }}
          description={t(getAttentionText(isMassAction))}
          onClose={handleCloseModal}
          onSubmit={handleCloseModal}
        />
      )
    } else {
      setModal(
        <ConfirmationModal
          actionButtonsProps={{
            submitText: t('Modal.DeleteBtnKey'),
          }}
          description={t('DocumentStapling.UploadingModalDeleteTextKey')}
          title={t('Modal.DeleteModalTitlekey')}
          onCancel={handleCloseModal}
          onSubmit={
            isMassAction
              ? getMassActionHandler({ action })
              : getDeleteItemHandler({ action, item })
          }
        />
      )
    }
  }

  return {
    handleDelete,
  }
}
